"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIMedia = _interopRequireDefault(require("UIComponents/layout/UIMedia"));

var _UIMediaRight = _interopRequireDefault(require("UIComponents/layout/UIMediaRight"));

var _UIMediaBody = _interopRequireDefault(require("UIComponents/layout/UIMediaBody"));

var _UIFireAlarm = _interopRequireDefault(require("UIComponents/alert/UIFireAlarm"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _Constants = require("FileManagerCore/Constants");

var _Constants2 = require("FileManagerLib/Constants");

var _FoldersAndFiles = require("FileManagerCore/utils/FoldersAndFiles");

var _Tiles = require("FileManagerLib/selectors/Tiles");

var _Tiles2 = require("FileManagerLib/utils/Tiles");

var _Filter = require("FileManagerLib/selectors/Filter");

var _FileExtensionFilters = _interopRequireDefault(require("FileManagerLib/enums/FileExtensionFilters"));

var _FilterHintMessage = _interopRequireDefault(require("FileManagerLib/components/browser/FilterHintMessage"));

var _hubLVideo = require("FileManagerLib/utils/hubLVideo");

var Actions = _interopRequireWildcard(require("FileManagerLib/actions/Actions"));

var _FoldersAndFilesContainer = _interopRequireDefault(require("FileManagerLib/containers/browser/FoldersAndFilesContainer"));

var _NoFiles = _interopRequireDefault(require("FileManagerLib/components/browser/NoFiles"));

var _SearchWithSuggestions = _interopRequireDefault(require("FileManagerLib/components/browser/SearchWithSuggestions"));

var _PickerVidyardBanner = _interopRequireDefault(require("FileManagerLib/components/browser/PickerVidyardBanner"));

var _FileManagerPortalData = require("FileManagerCore/actions/FileManagerPortalData");

var _Auth = require("FileManagerCore/selectors/Auth");

var _IdentityRepository = require("FileManagerCore/selectors/IdentityRepository");

var _FileManagerPortalData2 = require("FileManagerCore/selectors/FileManagerPortalData");

var _Files = require("FileManagerCore/selectors/Files");

var _Limits = require("FileManagerCore/selectors/Limits");

var _LoadingFailed = _interopRequireDefault(require("FileManagerCore/components/LoadingFailed"));

var _UILoadingOverlay = _interopRequireDefault(require("UIComponents/loading/UILoadingOverlay"));

var _network = require("FileManagerLib/utils/network");

function getVideoLimitBannerI18nKey(suffix) {
  return "FileManagerLib.videoLimit.banner." + suffix;
}

var BrowsePanel =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(BrowsePanel, _Component);

  function BrowsePanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, BrowsePanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BrowsePanel).call(this, props));
    _this.state = {
      isVideoLimitBannerDismissed: false
    };
    _this.handleCloseVideoLimitBanner = _this.handleCloseVideoLimitBanner.bind((0, _assertThisInitialized2.default)(_this));
    _this.getShouldEmbedVideoLimitBannerRender = _this.getShouldEmbedVideoLimitBannerRender.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLoadMoreRows = _this.handleLoadMoreRows.bind((0, _assertThisInitialized2.default)(_this));
    _this.fetch = _this.fetch.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BrowsePanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var maybeFetchFolders = this.props.maybeFetchFolders;
      maybeFetchFolders();
      this.fetch({
        initial: true
      });
    }
  }, {
    key: "handleCloseVideoLimitBanner",
    value: function handleCloseVideoLimitBanner() {
      this.setState({
        isVideoLimitBannerDismissed: true
      });
    }
  }, {
    key: "shouldVidyardBannerRender",
    value: function shouldVidyardBannerRender() {
      var _this$props = this.props,
          type = _this$props.type,
          vidyardTosStatus = _this$props.vidyardTosStatus,
          hasVideoIntegrationScope = _this$props.hasVideoIntegrationScope;
      return type === _Constants2.DrawerTypes.HUBL_VIDEO && hasVideoIntegrationScope && vidyardTosStatus !== _Constants.VidyardTosStatus.ACCEPTED;
    }
  }, {
    key: "fetch",
    value: function fetch() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props2 = this.props,
          fetchFiles = _this$props2.fetchFiles,
          type = _this$props2.type;
      fetchFiles((0, _extends2.default)({}, options, {
        type: type
      }));
    }
  }, {
    key: "getShouldEmbedVideoLimitBannerRender",
    value: function getShouldEmbedVideoLimitBannerRender() {
      var isVideoLimitBannerDismissed = this.state.isVideoLimitBannerDismissed;
      var _this$props3 = this.props,
          hasUserExceededVideoLimit = _this$props3.hasUserExceededVideoLimit,
          type = _this$props3.type;
      return (0, _hubLVideo.shouldVideoLimitBannerRender)({
        isVideoLimitBannerDismissed: isVideoLimitBannerDismissed,
        hasUserExceededVideoLimit: hasUserExceededVideoLimit,
        type: type
      });
    }
  }, {
    key: "getHeading",
    value: function getHeading() {
      var type = this.props.type;

      switch (type) {
        case _Constants2.DrawerTypes.IMAGE:
          return _I18n.default.text('FileManagerLib.panels.recentImages');

        case _Constants2.DrawerTypes.VIDEO:
        case _Constants2.DrawerTypes.HUBL_VIDEO:
          return _I18n.default.text('FileManagerLib.panels.recentVideos');

        case _Constants2.DrawerTypes.DOCUMENT:
          return _I18n.default.text('FileManagerLib.panels.recentDocuments');

        default:
          return _I18n.default.text('FileManagerLib.panels.recentFiles');
      }
    }
  }, {
    key: "handleLoadMoreRows",
    value: function handleLoadMoreRows() {
      var _this$props4 = this.props,
          filesRequestStatus = _this$props4.filesRequestStatus,
          files = _this$props4.files;

      if (filesRequestStatus === _Constants.RequestStatus.PENDING) {
        return;
      }

      this.fetch({
        offset: files.count()
      });
    }
  }, {
    key: "renderVideoLimitBanner",
    value: function renderVideoLimitBanner(videoLimit) {
      return _react.default.createElement(_UIFireAlarm.default, {
        closeable: true,
        onClose: this.handleCloseVideoLimitBanner,
        titleText: _react.default.createElement(_FormattedMessage.default, {
          message: getVideoLimitBannerI18nKey('title')
        }),
        type: "warning",
        className: "m-bottom-6"
      }, _react.default.createElement("p", null, _react.default.createElement(_FormattedReactMessage.default, {
        message: getVideoLimitBannerI18nKey('message'),
        options: {
          limit: videoLimit,
          nextLimit: 500,
          filesLink: _react.default.createElement(_UILink.default, {
            href: (0, _network.getRedirectToFilesLocation)(),
            key: "link-to-files"
          }, _react.default.createElement(_FormattedMessage.default, {
            message: getVideoLimitBannerI18nKey('filesLink')
          }))
        }
      })));
    }
  }, {
    key: "renderVidyardBanner",
    value: function renderVidyardBanner() {
      var _this$props5 = this.props,
          inferredUserRole = _this$props5.inferredUserRole,
          _updateVidyardTosStatus = _this$props5.updateVidyardTosStatus,
          isFileManagerPortalDataUpdatePending = _this$props5.isFileManagerPortalDataUpdatePending,
          vidyardTosStatus = _this$props5.vidyardTosStatus,
          total = _this$props5.total;
      return _react.default.createElement(_PickerVidyardBanner.default, {
        hubLVideosCount: total,
        currentVidyardTosStatus: vidyardTosStatus,
        inferredUserRole: inferredUserRole,
        isFileManagerPortalDataUpdatePending: isFileManagerPortalDataUpdatePending,
        updateVidyardTosStatus: function updateVidyardTosStatus(vidyardTosSatus) {
          return _updateVidyardTosStatus(vidyardTosSatus);
        }
      });
    }
  }, {
    key: "renderFiles",
    value: function renderFiles() {
      var _this$props6 = this.props,
          tiles = _this$props6.tiles,
          total = _this$props6.total,
          onInsert = _this$props6.onInsert,
          filesRequestStatus = _this$props6.filesRequestStatus,
          type = _this$props6.type;

      if (filesRequestStatus === _Constants.RequestStatus.PENDING) {
        return _react.default.createElement(_UILoadingOverlay.default, {
          contextual: true
        });
      }

      if (filesRequestStatus === _Constants.RequestStatus.FAILED) {
        return _react.default.createElement(_LoadingFailed.default, null);
      }

      if (this.shouldVidyardBannerRender()) {
        return this.renderVidyardBanner(total);
      }

      if (filesRequestStatus === _Constants.RequestStatus.SUCCEEDED && total === 0) {
        return _react.default.createElement(_NoFiles.default, {
          type: type
        });
      }

      return _react.default.createElement(_FoldersAndFilesContainer.default, {
        type: type,
        tiles: tiles,
        total: total,
        onInsert: onInsert,
        onLoadMoreFiles: this.handleLoadMoreRows
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          browseFolders = _this$props7.browseFolders,
          type = _this$props7.type,
          isPanelInactive = _this$props7.isPanelInactive,
          videoLimit = _this$props7.videoLimit,
          filterType = _this$props7.filterType;
      return _react.default.createElement(_UIFlex.default, {
        direction: "column"
      }, !isPanelInactive && filterType !== _FileExtensionFilters.default.NONE && _react.default.createElement(_FilterHintMessage.default, {
        drawerType: type
      }), !isPanelInactive && _react.default.createElement(_SearchWithSuggestions.default, {
        type: type
      }), _react.default.createElement(_UIBox.default, {
        className: "m-top-6 flex-column",
        grow: 1,
        alignSelf: "stretch"
      }, !isPanelInactive && _react.default.createElement(_UIMedia.default, {
        align: "baseline"
      }, _react.default.createElement(_UIMediaBody.default, null, _react.default.createElement("h5", null, this.getHeading())), _react.default.createElement(_UIMediaRight.default, null, _react.default.createElement(_UILink.default, {
        onClick: browseFolders
      }, _react.default.createElement(_Small.default, null, _I18n.default.text('FileManagerLib.browseFolders'))))), this.getShouldEmbedVideoLimitBannerRender() && this.renderVideoLimitBanner(videoLimit), this.renderFiles()));
    }
  }]);
  return BrowsePanel;
}(_react.Component);

BrowsePanel.propTypes = {
  type: _react.PropTypes.oneOf(Object.keys(_Constants2.DrawerTypes)).isRequired,
  files: _react.PropTypes.instanceOf(_immutable.default.List),
  tiles: _react.PropTypes.instanceOf(_immutable.default.List),
  filesRequestStatus: _react.PropTypes.oneOf(Object.keys(_Constants.RequestStatus)),
  total: _react.PropTypes.number.isRequired,
  onInsert: _react.PropTypes.func.isRequired,
  fetchFiles: _react.PropTypes.func.isRequired,
  maybeFetchFolders: _react.PropTypes.func.isRequired,
  browseFolders: _react.PropTypes.func.isRequired,
  hasVideoIntegrationScope: _react.PropTypes.bool.isRequired,
  vidyardTosStatus: _react.PropTypes.oneOf(Object.keys(_Constants.VidyardTosStatus)).isRequired,
  isFileManagerPortalDataUpdatePending: _react.PropTypes.bool.isRequired,
  inferredUserRole: _react.PropTypes.string.isRequired,
  updateVidyardTosStatus: _react.PropTypes.func.isRequired,
  isPanelInactive: _react.PropTypes.bool.isRequired,
  hasUserExceededVideoLimit: _react.PropTypes.bool.isRequired,
  videoLimit: _react.PropTypes.number.isRequired,
  filterType: _react.PropTypes.oneOf(Object.keys(_FileExtensionFilters.default)).isRequired
};
BrowsePanel.defaultProps = {
  isPanelInactive: false
};

var mapStateToProps = function mapStateToProps(state, props) {
  var files = (0, _Files.getFiles)(state);
  var tiles = (0, _Tiles.getTiles)(state, props);
  return {
    files: files,
    tiles: tiles,
    total: (0, _Tiles2.getTotalFilteredTiles)({
      savedFilesCount: (0, _Files.getFilesTotal)(state),
      files: files,
      tiles: tiles
    }),
    filterType: (0, _Filter.getFilterType)(state),
    filesRequestStatus: (0, _Files.getFetchFilesRequestStatus)(state),
    hasVideoIntegrationScope: (0, _Auth.getHasVideoIntegrationScope)(state),
    vidyardTosStatus: (0, _FileManagerPortalData2.getVidyardTosStatus)(state),
    isFileManagerPortalDataUpdatePending: (0, _FileManagerPortalData2.getFileManagerPortalDataUpdateRequestStatus)(state) === _Constants.RequestStatus.PENDING,
    inferredUserRole: (0, _IdentityRepository.getInferredUserRole)(state),
    hasUserExceededVideoLimit: (0, _Limits.getHasUserExceededEmbeddableVideoLimit)(state),
    videoLimit: (0, _Limits.getEmbeddableVideoLimit)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    browseFolders: function browseFolders() {
      dispatch(Actions.setPanel({
        activePanel: _Constants2.Panels.FOLDER,
        selectedFolder: (0, _FoldersAndFiles.getHomeFolder)()
      }));
    },
    maybeFetchFolders: function maybeFetchFolders() {
      dispatch(Actions.maybeFetchFolders());
    },
    fetchFiles: function fetchFiles(options) {
      var initial = options.initial,
          queryOpts = (0, _objectWithoutProperties2.default)(options, ["initial"]);
      var query = (0, _extends2.default)({
        limit: _Constants2.DEFAULT_ROWS_TO_FETCH * _Constants2.IMAGE_COLUMN_COUNT
      }, queryOpts, (0, _network.getProviderParam)(ownProps.type));

      if (initial) {
        dispatch(Actions.fetchInitialFiles(query, ownProps.type));
      } else {
        dispatch(Actions.fetchMoreFiles(query, ownProps.type));
      }
    },
    updateVidyardTosStatus: function updateVidyardTosStatus(status) {
      return dispatch((0, _FileManagerPortalData.getUpdateVidyardTosStatus)(status));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BrowsePanel);

exports.default = _default;
module.exports = exports.default;